import { getSkillQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/skillKeys.js';
import { getSkill } from '#pplx/frontend/apps/ask/skills/hooks/getSkill.js';
import { getSkillIdFromShareSlug } from '#pplx/frontend/apps/ask/skills/utils/getSkillShareURL.js';
import { formatComputerSkillDocumentTitle } from '#pplx/frontend/apps/ask/spa/metadata/computerMetadataTitles.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { useIntl } from 'react-intl';
export function useComputerSkillDocumentTitle({ slug, skillId: explicitSkillId, enabled, }) {
    const { $t } = useIntl();
    const skillId = slug ? getSkillIdFromShareSlug(slug, explicitSkillId) : null;
    const shouldFetchTitle = enabled && !!skillId;
    const { data } = useQuery({
        queryKey: getSkillQueryKey(shouldFetchTitle ? skillId : 'disabled'),
        queryFn: () => getSkill(skillId, 'computer-skill-document-title'),
        enabled: shouldFetchTitle,
        retry: false,
        staleTime: 30 * 60 * 1000,
    });
    return formatComputerSkillDocumentTitle(data?.skill?.name, $t);
}
//# sourceMappingURL=useComputerSkillDocumentTitle.js.map